import { type Maybe } from '@adornis/base/utilTypes.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';

import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('bh-prompt-phone-number')
export class BHPromptPhoneNumber extends TrDialog<Maybe<string>> {
  @property({ attribute: false }) user = new RXController<Maybe<User>>(this, undefined);

  @state() private phonenumber = '';

  override render() {
    if (this.user.isLoading || !this.user.value) {
      return html` <x-loading-state no-wrapper></x-loading-state> `;
    }

    return html`
      <x-flex space="md">
        <x-h2> ${this._translation.translate('REGISTRATION', 'phone_number_edit')} </x-h2>

        <tr-tel-input
          placeholderMode="inline-floating"
          placeholder="${this._translation.translate('PROFILE', 'NOTIFICATIONS', 'numberPlaceholder')}"
          @value=${this.phonenumber}
          @value-picked=${(e: CustomEvent) => (this.phonenumber = e.detail.value)}
        ></tr-tel-input>

        <x-flex horizontal space-between crossaxis-center space="md" wrap>
          <x-button mode="outline" @click=${() => this.cancel()}> ${this._translation.translate('discard')} </x-button>
          <x-button @click=${() => this.close(this.phonenumber)}> ${this._translation.translate('save')} </x-button>
        </x-flex>
      </x-flex>
    `;
  }

  override async cancel(returnVal?: any): Promise<void> {
    await this.close(null);
  }

  override getInnerWrapper(options: any) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty('background', this.colors.white);
    wrapperElem.style.setProperty('border-radius', this.sizes.borderRadius);
    wrapperElem.style.setProperty('width', `min(550px, 95%)`);
    wrapperElem.style.setProperty('padding', this.spacing.lg);
    return wrapperElem;
  }

  static override get element_name() {
    return 'bh-prompt-phone-number';
  }
}
